module.exports = __webpack_public_path__ + "img/ta-ny-leftTitleBg01.d153f043.png";